import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

// Sentry.init({
//   dsn: "https://5154621bcf335c77d4447052f39e4e94@o4507682606022656.ingest.us.sentry.io/4507683082993664",
//   tracesSampleRate: 1,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1,

//   integrations: [
//     Sentry.browserTracingIntegration({
//       useEffect,
//       useLocation,
//       useMatches,
//     }),
//     Sentry.replayIntegration(),
//   ],
// });

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
